import React from "react";
import Section from "../components/section/section";
import { useStore } from "../store";
import HexagonButton from "../components/hexagon-button/hexagon-button";
import Hexagon1 from "../components/hexagon-1";
import Hexagon2 from "../components/hexagon-2";
import Hexagon3 from "../components/hexagon-3";

export default function EndFrame21() {
  const { section, setSection, showEndFrame } = useStore();
  const watchedSections = React.useMemo(() => {
    return (
      JSON.parse(window.localStorage.getItem(`kasperskey.watchedSections`)) ??
      []
    );
  }, [section]);

  if (section !== 2.1 || !showEndFrame) return null;

  return (
    <Section name="2-1">
      <div className="flex-div">
        <HexagonButton
          onClick={() => setSection(2.1)}
          disabled={watchedSections.includes(2.1)}
        >
          <div className="hexagon-button-flex">
            <img src="./assets/icons/001-back.svg" className="Shape__icon" />
            Socks
          </div>
          <Hexagon1 />
        </HexagonButton>
        <HexagonButton
          onClick={() => setSection(2.2)}
          disabled={watchedSections.includes(2.2)}
        >
          <div className="hexagon-button-flex">
            <img
              src="./assets/icons/003-hawaiian-shirt.svg"
              className="Shape__icon"
            />
            Hawaiian <br /> Shirt
          </div>
          <Hexagon2 />
        </HexagonButton>
        <HexagonButton
          onClick={() => setSection(2.3)}
          disabled={watchedSections.includes(2.3)}
        >
          <div className="hexagon-button-flex">
            <img
              src="./assets/icons/005-carnival-mask.svg"
              className="Shape__icon"
            />
            Fancy <br />
            Dress
          </div>
          <Hexagon3 />
        </HexagonButton>
      </div>
      <div className="flex-div">
        <HexagonButton
          onClick={() => setSection(2.4)}
          disabled={watchedSections.includes(2.4)}
        >
          <div className="hexagon-button-flex">
            <img src="./assets/icons/004-kimono.svg" className="Shape__icon" />
            Kimono
          </div>
          <Hexagon3 />
        </HexagonButton>
        <HexagonButton
          onClick={() => setSection(2.5)}
          disabled={watchedSections.includes(2.5)}
        >
          <div className="hexagon-button-flex">
            <img src="./assets/icons/011-t-shirt.svg" className="Shape__icon" />
            Casual
          </div>
          <Hexagon3 />
        </HexagonButton>
      </div>
    </Section>
  );
}
